import store from '../../../../store';
import { EventBus } from '../../../../services/event-bus-service';
import { AGENT_PERMISSIONS } from '../../../../agent/services/permissions/permissions-enum';
import { ITEM_TYPES, BETSLIP_STATUS } from '../../../../models/enums/betslip-constants';
import { CASHOUT_ON_DEMAND_STEPS, CASHOUT_ERROR_CODES } from '../../../../models/enums/mybets-const';
import PlayerPermissionsService from '../../../../agent/services/permissions/player-permissions-service';
import BetslipPrintService from '@bto-services/print/betslip-print-service';
import CashoutService from '../../../../services/mybets/cashout-request-service.js';
import InlineMessageComponent from '../../../../components/shared/inline-message-component';
import RebetButton from './buttons/rebet-button';
import PaidButton from './buttons/paid-button';
import CancelPlacedBetslipButton from './buttons/cancel-placed-betslip-button';
import CashoutOnDemand from './buttons/cashout-on-demand';
export default {
  components: {
    InlineMessageComponent,
    PaidButton,
    RebetButton,
    CancelPlacedBetslipButton,
    CashoutOnDemand,
  },
  data() {
    return {
      IS_AGENT: process.env.VUE_APP_IS_AGENT,
      // start cashout logic
      cashoutStep: 0,
      cashoutBtnName: '',
      cashoutMsg: '',
      cashoutCircularLoader: false,
      isDisabled: false,
      // end cashout logic
      cashoutOnDemandStep: 1,
      cashoutOnDemandAmount: 0,
      cashoutOnDemandMsg: null,
      cashoutNewOffer: 0,
      bps: null,
      inlineMsg: {
        betslipId: 0,
        type: 'success',
        text: '',
      },
    };
  },
  props: {
    betDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showRebet() {
      if (!this.betDetails.items) {
        return false;
      }
      const showRebet = APP_SETTINGS.betslip_v2.showRebet;
      return this.betDetails.items.some(i => i.itemStatusId === BETSLIP_STATUS.PLACED) && showRebet;
    },
    cashoutVal() {
      return this.cashoutNewOffer || store.getters.getCashoutByBetslipGroupId(this.betDetails.betSlipGroupID);
    },
    showCashout() {
      return this.betDetails.betSlipGroupStatusId === BETSLIP_STATUS.PLACED;
    },
    showPaidBtn() {
      // if web hide paid button
      if (!this.IS_AGENT) {
        return false;
      }
      // if outside betslip checker hide button
      if (!this.$route.params.identifier) {
        return false;
      }
      // if status is different than won hide button
      if (this.betDetails.betSlipGroupStatusId !== BETSLIP_STATUS.WON) {
        return false;
      }
      // if user has 'DisablePayBetslips' permission hide button
      if (PlayerPermissionsService.get(AGENT_PERMISSIONS.DisablePayBetslips)) {
        return false;
      }
      // period in Days from setting
      const payoutPeriod = (APP_SETTINGS.agentSettings && +APP_SETTINGS.agentSettings.payoutPeriod) || 1;
      const timePeriod = payoutPeriod * 24 * 60 * 60 * 1000;
      const curTimeStamp = new Date().getTime();
      const bsDateTime = this.betDetails.datetime.indexOf('Z') > -1 ? this.betDetails.datetime : `${this.betDetails.datetime}Z`;
      const bsTimeStamp = new Date(bsDateTime).getTime();
      const inTimeLimit = (bsTimeStamp + timePeriod) > curTimeStamp;
      // if time limit has passed hide button
      if (!inTimeLimit) {
        return false;
      }
      return true;
    },
    showCancelPlacedBtn() {
      if (!this.IS_AGENT) {
        return false;
      }
      if (this.betDetails.betSlipGroupStatusId !== BETSLIP_STATUS.PLACED && this.betDetails.betSlipGroupStatusId !== BETSLIP_STATUS.PENDING) {
        return false;
      }
      // if the BS group has at least one live item
      if (this.betDetails.items.findIndex(i => i.itemType === ITEM_TYPES.LIVE) > -1) {
        return false;
      }
      if (PlayerPermissionsService.get(AGENT_PERMISSIONS.CanForceCancelBetSlip)) {
        return true;
      }
      // period in minutes from setting
      const cancelPeriod = (APP_SETTINGS.agentSettings && +APP_SETTINGS.agentSettings.cancelPeriod) || 1;
      const timePeriod = cancelPeriod * 60 * 1000;
      const curTimeStamp = new Date().getTime();
      const bsDateTime = this.betDetails.datetime.indexOf('Z') > -1 ? this.betDetails.datetime : `${this.betDetails.datetime}Z`;
      const bsTimeStamp = new Date(bsDateTime).getTime();
      const inTimeLimit = (bsTimeStamp + timePeriod) > curTimeStamp;
      if (inTimeLimit && PlayerPermissionsService.get(AGENT_PERMISSIONS.CanCancelBetSlip)) {
        return true;
      }
      return false;
    },
    canPrintBetSlipFromHistory() {
      // hide print for these BetslipGroup statuses
      switch (this.betDetails.betSlipGroupStatusId) {
        case BETSLIP_STATUS.PENDING:
        case BETSLIP_STATUS.REJECTED:
        case BETSLIP_STATUS.VOID:
          // case BETSLIP_STATUS.CANCELLED:
          return false;
      }
      // if agent check permission. If web  check setting
      let showBtn = false;
      if (process.env.VUE_APP_IS_AGENT) {
        showBtn = PlayerPermissionsService.get(AGENT_PERMISSIONS.CanPrintBetSlipFromHistory);
      } else {
        showBtn = typeof APP_SETTINGS.print.showPrintButton !== 'undefined'
          ? APP_SETTINGS.print.showPrintButton
          : true;
      }
      return showBtn;
    },
    showOnDemandCashout() {
      // On demand cashout is only available for agent
      if (!this.IS_AGENT) {
        return false;
      }
      // Hide if outside betslip checker
      if (!this.$route.params.identifier) {
        return false;
      }
      // Hide if bet status is different than placed
      if (this.betDetails.betSlipGroupStatusId !== BETSLIP_STATUS.PLACED) {
        return false;
      }
      // Hide if agent has DisableCashoutAgent permission
      if (PlayerPermissionsService.get(AGENT_PERMISSIONS.DisableCashoutAgent)) {
        return false;
      }
      // Hide if cashout is Done
      if (this.cashoutOnDemandStep === CASHOUT_ON_DEMAND_STEPS.DONE) {
        return false;
      }
      return true;
    },
  },
  created() {
    this.cashoutBtnName = this.$translate.text('BetSlip.cashout.cashoutButton');
    const ticketW = typeof APP_SETTINGS.print !== 'undefined' ? APP_SETTINGS.print.printTicketWidth : '';
    this.bps = new BetslipPrintService(ticketW);
    EventBus.$on('cashedOutMsg', this.cashedOutMsgHandler);
  },
  destroyed() {
    EventBus.$off('cashedOutMsg', this.cashedOutMsgHandler);
  },
  methods: {
    cashedOutMsgHandler(resp) {
      const betId = this.betDetails.betSlipGroupID;
      if (resp.BetslipGroupId === betId) {
        if (this.IS_AGENT) {
          this.handleAgentCashout(resp);
        } else {
          this.cashedOutResp(resp);
        }
      }
    },
    processCashout(cashoutValue) {
      const cashoutService = new CashoutService();
      switch (this.cashoutStep) {
        // first click ask for confirmation
        case 0:
          this.cashoutStep = 1;
          this.cashoutBtnName = this.$translate.text('Mobile.confirmcashout');
          break;
        case 1:
        case 3: {
          const betId = this.betDetails.betSlipGroupID;
          cashoutService.postParams.betSlipGroupID = betId;
          cashoutService.postParams.Amount = cashoutValue;
          this.cashoutCircularLoader = true;
          cashoutService.execute();
          break;
        }
        default:
          this.cancelCashout();
      }
    },
    cashedOutResp(resp) {
      this.cashoutCircularLoader = false;
      if (resp.ErrorCode === CASHOUT_ERROR_CODES.NEW_OFFER && resp.Amount) {
        this.cashoutStep = 3;
        this.cashoutBtnName = this.$translate.text('W.acceptcashout');
        this.cashoutMsg = this.$translate.text('W.changedcashout');
        this.cashoutNewOffer = resp.Amount;
        return;
      }
      if (resp.ErrorCode === CASHOUT_ERROR_CODES.ERROR) {
        this.cancelCashout(resp.Message);
        return;
      }
      if (resp.ErrorCode === CASHOUT_ERROR_CODES.SUCCESS) {
        const betId = this.betDetails.betSlipGroupID;
        this.$emit('cashedOutBetToRemove', betId);
        this.cashoutStep = 4;
        this.cashoutBtnName = resp.Message;
        this.cashoutMsg = resp.Message;
        this.isDisabled = true;
        return;
      }
      this.cashoutStep = 2;
      this.cashoutMsg = resp.Message;
      this.cashoutNewOffer = 0;
    },
    cancelCashout(msg = '') {
      this.cashoutStep = 0;
      this.cashoutMsg = msg;
      this.cashoutBtnName = this.$translate.text('BetSlip.cashout.cashoutButton');
      this.isDisabled = false;
    },
    handleAgentCashout(resp) {
      switch (resp.ErrorCode) {
        case CASHOUT_ERROR_CODES.SUCCESS:
          this.changeOnDemandStep(CASHOUT_ON_DEMAND_STEPS.DONE);
          this.changeOnDemandMsg({
            type: 'success',
            text: resp.Message,
          });
          this.$emit('onBetCashout');
          return;
        case CASHOUT_ERROR_CODES.NEW_OFFER:
          this.changeOnDemandAmount({
            amount: resp.Amount,
            step: (resp.Amount > 0) ? CASHOUT_ON_DEMAND_STEPS.NEW_OFFER : CASHOUT_ON_DEMAND_STEPS.UNAVAILABE,
          });
          return;
        case CASHOUT_ERROR_CODES.ERROR:
          this.changeOnDemandStep(CASHOUT_ON_DEMAND_STEPS.INITAL);
          this.changeOnDemandMsg({
            type: 'error',
            text: resp.Message,
          });
          return;
        case CASHOUT_ERROR_CODES.UNAVAILABLE:
        default:
          this.changeOnDemandStep(CASHOUT_ON_DEMAND_STEPS.UNAVAILABLE);
          this.changeOnDemandMsg({
            type: 'warning',
            text: resp.Message,
          });
      }
    },
    checkPrintStatus() {
      switch (this.betDetails.betSlipGroupStatusId) {
        case BETSLIP_STATUS.CANCELLED:
          return 'Global.BetslipFooterTicketCanceled';
        case BETSLIP_STATUS.WON:
          if (this.betDetails.combinations.findIndex(c => c.combinationStatusId === BETSLIP_STATUS.PAID) > -1) {
            return 'Global.BetslipFooterTicketPaid';
          }
          break;
        case BETSLIP_STATUS.PAID:
          return 'Global.BetslipFooterTicketPaid';
      }
      return 'Global.BetslipFooterTicketReprint';
    },
    printTicket(event, status = "") {
      const printStatus = status || this.checkPrintStatus();
      this.bps.printBetslip(event, this.betDetails.betSlipGroupID, this.betDetails, false, printStatus);
    },
    printCancelTicket(event) {
      this.betDetails.betSlipGroupStatusId = BETSLIP_STATUS.CANCELLED;
      this.betDetails.betSlipGroupStatus = this.$translate.text('BetSlipStatusType.Cancelled');
      this.betDetails.combinations.forEach((comb) => { comb.winnings = comb.stake; });
      this.betDetails.winnings = this.betDetails.stake;
      this.betDetails.potWinnings = 0;
      this.bps.printBetslip(event, this.betDetails.betSlipGroupID, this.betDetails, false, this.checkPrintStatus());
    },
    changeStatusPaid() {
      this.betDetails.betSlipGroupStatusId = BETSLIP_STATUS.PAID;
      this.betDetails.betSlipGroupStatus = this.$translate.text('BetSlipStatusType.Paid');
    },
    setInlineMsg(msg) {
      if (msg.betslipId === this.betDetails.betSlipGroupID) {
        this.inlineMsg = msg;
        this.$emit('setInlineMessage', msg);
      }
    },
    changeOnDemandStep(step) {
      this.changeOnDemandMsg(null);
      this.cashoutOnDemandStep = step;
    },
    changeOnDemandAmount({ amount, step }) {
      this.cashoutOnDemandAmount = amount;
      this.changeOnDemandStep(step);
    },
    changeOnDemandMsg(msg) {
      this.cashoutOnDemandMsg = msg;
      this.$emit('setInlineMessage', msg);
    },
  },
};
